<template>
    <span>
    <span class="text-success" v-if="isOk">
        <font-awesome-icon v-if="showIcons" :icon="statusIcon('OK')" class="mr-1"/><span v-if="showText">OK</span>
    </span>
    <template v-else>
        <span v-for="(s, idx) in statuses" :key="s" :class="statusClass(s)">{{(showText && (idx !== 0)) ? ',' : '' }}
            <font-awesome-icon v-if="showIcons" :icon="statusIcon(s)" class="mr-1" :title="statusLabel(s)"/>{{ showText ? statusLabel(s) : '' }}</span>
    </template>
    </span>
</template>

<script>
    import {EVENTS} from "../events";

    export default {
        name: "GatewaySummary",
        props: ["showText", "showIcons", "statuses"],
        computed: {
            isOk() {
                return this.statuses.length === 0;
            }
        },
        methods: {
            statusIcon(key) {
                return EVENTS[key].icon;
            },
            statusLabel(key) {
                return EVENTS[key].text;
            },
            statusClass(key) {
                return "text-" + EVENTS[key].color;
            }
        }
    }
</script>

<style scoped>

</style>